// =====================================================================
// destinosManualConfig.js
// Una plantilla por hoja del Excel Cotizador_VV170326.xlsm.
// Cada plantilla indica su tipo de formulario, la función de cálculo
// (nombre exportado en calculos.js) y los textos del segundo mensaje.
// =====================================================================

import { textosIncluye } from "./textosIncluye"

const configs = {
  // ------------------------- TC INTERNACIONAL -------------------------
  internacional: {
    label: "TC Internacional",
    tipo: "estandar",
    calculo: "tcInternacional",
    usaTrm: true,
    usaTraslados: true,
    grupos: [
      {
        key: "ti",
        label: "Hoteles Todo Incluido",
        plan: "todo incluido",
        texto: textosIncluye.INTERNACIONAL_TI
      },
      {
        key: "desayuno",
        label: "Hoteles Sólo Desayuno",
        plan: "solo desayuno",
        texto: textosIncluye.INTERNACIONAL_DESAYUNO
      }
    ]
  },

  // --------------------------- TC NACIONAL ----------------------------
  nacional: {
    label: "TC Nacional",
    tipo: "estandar",
    calculo: "tcNacional",
    usaTrm: false,
    usaTraslados: false,
    notas: [
      "Si cotizas Amazonas debes sumar a los vuelos 80.000 (todo incluido) o 60.000 (solo desayuno) por el traslado."
    ],
    grupos: [
      {
        key: "ti",
        label: "Hoteles Todo Incluido",
        plan: "todo incluido",
        texto: textosIncluye.NACIONAL_TI
      },
      {
        key: "desayuno",
        label: "Hoteles Sólo Desayuno",
        plan: "solo desayuno",
        texto: textosIncluye.NACIONAL_DESAYUNO
      }
    ]
  },

  // ----------------------------- TC MEX -------------------------------
  mex: {
    label: "TC México (CDMX)",
    tipo: "estandar",
    calculo: "tcMex",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Ciudad de México",
    notas: ["Incluye tours en Ciudad de México según cantidad de personas."],
    grupos: [
      {
        key: "desayuno",
        label: "Hoteles Sólo Desayuno",
        plan: "solo desayuno",
        texto: textosIncluye.MEX
      }
    ]
  },

  // --------------------------- TC MEX-CUN -----------------------------
  mexCun: {
    label: "TC México + Cancún",
    tipo: "combinado",
    calculo: "tcMexCun",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Ciudad de México y Cancún",
    texto: textosIncluye.MEX_CUN,
    grupoA: { label: "Hoteles Ciudad de México (sólo desayuno)" },
    grupoB: [
      {
        key: "cunTi",
        label: "Hoteles Cancún Todo Incluido",
        plan: "todo incluido"
      }
    ]
  },

  // ----------------------------- TC CUN -------------------------------
  cancun: {
    label: "TC Cancún",
    tipo: "estandar",
    calculo: "tcCancun",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Cancún",
    grupos: [
      {
        key: "ti",
        label: "Hoteles Todo Incluido",
        plan: "todo incluido",
        texto: textosIncluye.CUN
      }
    ]
  },

  playaDelCarmen: {
    label: "TC Playa del Carmen",
    tipo: "estandar",
    calculo: "tcPlayaDelCarmen",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Playa del Carmen",
    grupos: [
      {
        key: "ti",
        label: "Hoteles Todo Incluido",
        plan: "todo incluido",
        texto: textosIncluye.CUN
      }
    ]
  },

  // ----------------------------- TC PUJ -------------------------------
  puntaCana: {
    label: "TC Punta Cana",
    tipo: "estandar",
    calculo: "tcPuntaCana",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Punta Cana",
    grupos: [
      {
        key: "ti",
        label: "Hoteles Todo Incluido",
        plan: "todo incluido",
        texto: textosIncluye.PUJ
      }
    ]
  },

  // ---------------------------- TC CUBA -------------------------------
  varadero: {
    label: "TC Cuba – Varadero",
    tipo: "estandar",
    calculo: "tcVaradero",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Varadero",
    notas: ["No incluye el pago de la visa electrónica a Cuba."],
    grupos: [
      {
        key: "ti",
        label: "Hoteles Todo Incluido",
        plan: "todo incluido",
        texto: textosIncluye.VARADERO
      }
    ]
  },

  habana: {
    label: "TC Cuba – Habana",
    tipo: "estandar",
    calculo: "tcHabana",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Habana",
    notas: ["No incluye el pago de la visa electrónica a Cuba."],
    grupos: [
      {
        key: "desayuno",
        label: "Hoteles Sólo Desayuno",
        plan: "solo desayuno",
        texto: textosIncluye.HABANA
      }
    ]
  },

  varaderoHabana: {
    label: "TC Cuba – Varadero + Habana",
    tipo: "combinado",
    calculo: "tcVaraderoHabana",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Varadero y Habana",
    texto: textosIncluye.VARADERO_HABANA,
    notas: ["No incluye el pago de la visa electrónica a Cuba."],
    grupoA: { label: "Hoteles Habana (sólo desayuno)" },
    grupoB: [
      {
        key: "varTi",
        label: "Hoteles Varadero Todo Incluido",
        plan: "todo incluido"
      }
    ]
  },

  // --------------------------- TC PANAMA ------------------------------
  panamaPlaya: {
    label: "TC Panamá – Playa",
    tipo: "estandar",
    calculo: "tcPanamaPlaya",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Panamá",
    notas: [
      "Recargo nocturno de traslados (6PM-6AM): 20 USD por trayecto por persona. Se agrega manualmente."
    ],
    grupos: [
      {
        key: "ti",
        label: "Hoteles Todo Incluido",
        plan: "todo incluido",
        texto: textosIncluye.PANAMA_PLAYA
      }
    ]
  },

  panamaCiudad: {
    label: "TC Panamá – Ciudad",
    tipo: "estandar",
    calculo: "tcPanamaCiudad",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Ciudad de Panamá",
    notas: [
      "Recargo nocturno de traslados (6PM-6AM): 20 USD por trayecto por persona. Se agrega manualmente."
    ],
    grupos: [
      {
        key: "desayuno",
        label: "Hoteles Sólo Desayuno",
        plan: "solo desayuno",
        texto: textosIncluye.PANAMA_CIUDAD
      }
    ]
  },

  panamaCombinado: {
    label: "TC Panamá – Playa + Ciudad",
    tipo: "combinado",
    calculo: "tcPanamaCombinado",
    usaTrm: true,
    usaTraslados: false,
    destinoFijo: "Panamá",
    texto: textosIncluye.PANAMA_COMBINADO,
    notas: [
      "Recargo nocturno de traslados (6PM-6AM): 20 USD por trayecto por persona. Se agrega manualmente."
    ],
    grupoA: { label: "Hoteles Ciudad de Panamá (sólo desayuno)" },
    grupoB: [
      {
        key: "playaTi",
        label: "Hoteles Playa Todo Incluido",
        plan: "todo incluido"
      }
    ]
  },

  // ------------------------ OTROS DESTINOS USD ------------------------
  otrosUsd: {
    label: "Otros destinos (USD)",
    tipo: "otrosUsd",
    calculo: "tcOtrosUSD",
    usaTrm: true,
    usaTraslados: false,
    notas: ["El hotel se digita en USD (neto Travel Compositor). El resultado se entrega en USD."],
    grupos: [
      {
        key: "hoteles",
        label: "Hoteles (valor total en USD)",
        plan: "",
        texto: textosIncluye.OTROS
      }
    ]
  },

  // --------------------------- SAN ANDRES -----------------------------
  sanAndres: {
    label: "San Andrés",
    tipo: "sanAndres",
    usaTrm: false,
    usaTraslados: false,
    destinoFijo: "San Andrés",
    texto: textosIncluye.SAN_ANDRES,
    notas: [
      "Los hoteles todo incluido usan el tarifario por noche (SGL/DBL/CHD). Completa las tarifas en destinosManualConfig.js."
    ],
    // Tarifario por noche del Excel (hojas SAN ANDRES TBAJA / TALTA).
    // Formato: { nombre, sgl, dbl, chd } — valores por noche en COP.
    hotelesTI: []
  },

  // ------------------------- COSTA (SMR / CTG) ------------------------
  santaMarta: {
    label: "Santa Marta (temporada baja)",
    tipo: "costa",
    calculo: "costaConAlimentacion",
    usaTrm: false,
    usaTraslados: false,
    destinoFijo: "Santa Marta",
    texto: textosIncluye.COSTA,
    restriccion: "Tarifas de temporada baja",
    planes: ["Desayuno y Cena", "Todo Incluido"]
  },

  cartagena: {
    label: "Cartagena (temporada baja)",
    tipo: "costa",
    calculo: "costaConAlimentacion",
    usaTrm: false,
    usaTraslados: false,
    destinoFijo: "Cartagena",
    texto: textosIncluye.COSTA,
    restriccion: "Tarifas de temporada baja",
    planes: ["Desayuno y Cena", "Todo Incluido"]
  },

  // -------------------------- GRUPOS TRAVEL ---------------------------
  gruposTravel: {
    label: "Grupos Travel",
    tipo: "gruposTravel",
    calculo: "gruposTravel",
    usaTrm: false,
    usaTraslados: false,
    grupos: [
      {
        key: "ti",
        label: "Hoteles Todo Incluido",
        plan: "todo incluido",
        texto: textosIncluye.GRUPOS_TRAVEL_TI
      },
      {
        key: "dc",
        label: "Hoteles Desayuno y Cena",
        plan: "desayuno y cena",
        texto: textosIncluye.GRUPOS_TRAVEL_DC
      },
      {
        key: "desayuno",
        label: "Hoteles Sólo Desayuno",
        plan: "solo desayuno",
        texto: textosIncluye.GRUPOS_TRAVEL_DESAYUNO
      }
    ]
  },

  // ------------------------------ TOURS -------------------------------
  turquia: {
    label: "Turquía",
    tipo: "tour",
    calculo: "turquia",
    usaTrm: true,
    saludo: textosIncluye.TURQUIA,
    incluye: textosIncluye.TURQUIA_INCLUYE,
    notas: [
      "El vuelo sale 1 día antes del inicio del plan y regresa 10 días después de la ida."
    ]
  },

  tailandia: {
    label: "Tailandia",
    tipo: "tour",
    calculo: "tailandia",
    usaTrm: true,
    saludo: textosIncluye.TAILANDIA,
    incluye: textosIncluye.TAILANDIA_INCLUYE,
    notas: [
      "El vuelo sale 2 días antes del inicio del plan; vuelo interno al día 9 y regreso al día 13."
    ]
  },

  // ----------------------------- CRUCERO ------------------------------
  cruceroCtg: {
    label: "Crucero desde Cartagena",
    tipo: "crucero",
    calculo: "cruceroCtg",
    usaTrm: false,
    texto: textosIncluye.CRUCERO,
    notas: [
      "La naviera se asigna automáticamente según la fecha de salida (Serenade / Grandeur of the Seas)."
    ]
  }
}

export const destinosManual = Object.entries(configs).map(([value, cfg]) => ({
  value,
  label: cfg.label
}))

export function getDestinoManual(value) {
  return configs[value] ?? null
}
